module.exports = __webpack_public_path__ + "static/media/Ashmayu_W.6bd919f6.png";